import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import { PlayIcon } from 'components/atoms/icons/play';
import { openInNewTab } from 'infrastructure/functions';
import BaseLoader from 'components/atoms/base-loader';
import { useGetAudioComment } from 'infrastructure/hooks/comments/use-get-audio';

import s from './styles.module.scss';

interface IProps {
  callGuid: string;
  patientGuid: string;
}

const RecordingCol: React.FC<IProps> = ({ callGuid, patientGuid }) => {
  const { loading, getAudioCommentUrl } = useGetAudioComment(patientGuid);

  const openCall = async () => {
    const res = await getAudioCommentUrl(callGuid);
    if (res) openInNewTab(res.url);
  };

  return (
    <BaseLoader loading={loading} relative width={15} height={15}>
      <div className={s.recording} onClick={openCall}>
        <div>
          <BaseButton type="secondary" icon={<PlayIcon />} />
          {callGuid}
        </div>
      </div>
    </BaseLoader>
  );
};

export default RecordingCol;
